import React from 'react'
import { Layout } from '../../Layout'
import { PageMyPage } from '../../organisms'
import { Box, Colors } from '../../atoms'
import { RouteComponentProps } from 'react-router'
import { useMediaQuery } from 'react-responsive'
import { SP_MAX_WIDTH } from '../../../setting'

export interface MyPageProps extends RouteComponentProps {
  name?: string
}

export const MyPage = (_: MyPageProps) => {
  const isSp = useMediaQuery({
    query: `(max-device-width: ${SP_MAX_WIDTH})`
  })
  return (
    <Layout>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
        backgroundColor={isSp ? 'white' : Colors.bg.default}
      >
        <PageMyPage />
      </Box>
    </Layout>
  )
}
